import { Pipe, PipeTransform } from '@angular/core';
import { activeFeatures } from '@monsido/core/constants/general.constant';

@Pipe({
    name: 'activeFeature',
})

export class ActiveFeaturePipe implements PipeTransform {
    transform (value: keyof typeof activeFeatures): boolean {
        return activeFeatures[value] || false;
    }
}
